import { GlobeIcon } from "../icons"

const GOALS = [
  {
    number: "1",
    id: "SDG 1",
    name: "No Poverty",
    description: "Reducing the fee barrier that keeps children out of quality classrooms.",
  },
  {
    number: "4",
    id: "SDG 4",
    name: "Quality Education",
    description: "Expanding access to quality private schools for undereducated and out-of-school children.",
  },
  {
    number: "5",
    id: "SDG 5",
    name: "Gender Equality",
    description: "Micro-business education and grants for women.",
  },
  {
    number: "10",
    id: "SDG 10",
    name: "Reduced Inequalities",
    description: "Bridging under-resourced public schools to quality private schools.",
  },
  {
    number: "13",
    id: "SDG 13",
    name: "Climate Action",
    description: "Promoting climate-change education and awareness among children and young people — equipping them to take meaningful climate action.",
  },
]

export function AlignedGlobally() {
  return (
    <section className="bg-cream-50 py-10 lg:py-[60px]">
      <div className="public-container text-center">
        <span className="inline-flex items-center gap-2.5 rounded-full border border-ink/10 bg-cream-100 px-4 py-1.5 text-sm font-medium text-ink">
          <GlobeIcon />
          Aligned Globally
        </span>

        <div className="mx-auto mt-8">
          <h2 className="font-display text-[36px] font-bold leading-tight text-ink sm:text-[48px] sm:leading-none">
            UN <span className="text-forest-700">Sustainable Development Goals</span> we advance
          </h2>
          <p className=" text-base text-ink sm:text-lg">
            Our work sits inside a global framework — measurable, comparable, and open to partnership.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 text-left lg:mt-14 lg:grid-cols-4">
          {GOALS.map((goal) => (
            <article key={goal.number} className="flex min-h-[190px] flex-col rounded-2xl bg-white p-4 lg:min-h-[260px] lg:p-6">
              <span className="grid h-8 w-8 place-items-center rounded-lg bg-forest-950 font-display text-[24px] font-bold leading-none text-white lg:h-[49px] lg:w-[49px] lg:text-[28px]">
                {goal.number}
              </span>
              <div className="mt-[16px] lg:mt-[90px]">
                <p className="text-sm text-ink/60 lg:text-base">{goal.id}</p>
                <h3 className="mt-1 text-sm font-semibold text-ink lg:text-base">{goal.name}</h3>
                <p className="mt-2 text-xs leading-relaxed text-ink/70 lg:mt-3 lg:text-[15px]">{goal.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
